import type { DocumentRendererProps } from '@/lib/document-renderer-registry'
import { ProductBoard } from './product-board'

/**
 * Registry wrapper so product-board markdown docs use DocumentContent
 * Preview / Code (source) like flow and quiz. Board chrome stays in ProductBoard.
 */
export function ProductBoardDocumentRenderer({ document }: DocumentRendererProps) {
  const filePath = document.filePath ?? document.file_path
  return (
    <div className="h-full min-h-0">
      <ProductBoard
        documentId={document.id}
        documentFilePath={filePath}
        chrome="embedded"
      />
    </div>
  )
}
